import Container from 'app/components/common/Container';

import Member from './Member';
export default function OurMembers({
  members = [],
  head = 'Team',
  background = 'bg-our-team',
  backgroundPosition = 'center',
}) {
  return (
    <div
      className={`${background} ${backgroundPosition} bg-no-repeat md:pt-[75px] p-[30px]`}
    >
      <Container className="text-center">
        <h5 className="font-[800] xl:text-[50px] md:text-[32px] text-[26px] title_hd leading-tight text-center mb-[100px]">
          {`Our ${head}`}
        </h5>
        <section className={`flex flex-wrap justify-center gap-10`}>
          {members.length > 0 &&
            members.map((member, index) => (
              <Member
                key={index}
                {...member}
                noPadding={
                  index + 1 === 1 ||
                  (index + 1) % 4 === 0 ||
                  (index + 1) % 5 === 0 ||
                  index + 1 === members.length
                }
                paddingRight={index + 1 === 1 || (index + 1) % 5 === 0}
                paddingLeft={
                  index + 1 === members.length || (index + 1) % 4 === 0
                }
              />
            ))}
        </section>
      </Container>
    </div>
  );
}
